import { render, staticRenderFns } from "./ModalFechamentoId.vue?vue&type=template&id=104f29ac"
import script from "./ModalFechamentoId.vue?vue&type=script&lang=js"
export * from "./ModalFechamentoId.vue?vue&type=script&lang=js"
import style0 from "./ModalFechamentoId.vue?vue&type=style&index=0&id=104f29ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports